export default __webpack_public_path__ + "static/media/bergen_2.44635407.jpg";